import { render, staticRenderFns } from "./RulesSchedule.vue?vue&type=template&id=0a879122&lang=html&"
import script from "./RulesSchedule.vue?vue&type=script&lang=js&"
export * from "./RulesSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RulesSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports